function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      color: ", ";\n      cursor: default;\n\n      &:hover {\n        background-color: ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border: 2px solid ", ";\n    border-radius: 4px;\n    color: ", ";\n    padding: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    ", "\n\n    ", " {\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";
import { BaseButton, BaseButtonStyles } from "@diana-ui/button";
export default styled(BaseButton).attrs(props => ({
  disabled: !!props.disabled
}))((_ref) => {
  var {
    disabled,
    theme
  } = _ref;
  return css(_templateObject(), theme.colors.white, theme.colors.alert.alert100, theme.colors.alert.alert100, theme.spaceUnit.xs, theme.colors.alert.alert20, theme.colors.alert.alert60, disabled && css(_templateObject2(), theme.colors.alert.alert60, theme.colors.alert.alert60, theme.colors.white), BaseButtonStyles.StyledButtonText, theme.typography.detailText);
});